export const globals = {
  serverTime: 0,
};
